import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "src/common/axiosInstance";
import { getUsers as getUsersApi,
    addNewUser as addNewUserApi, deleteUser as deleteUserApi, updateUser as updateUserApi } from "../../helpers/fakebackendHelper";


export const getUsers: any = createAsyncThunk(
  "contacts/getUsers",
  async ({
    agency_id,
    page,
    limit,
    search,
    sort_column,
    sort_direction,
  }: {
    agency_id: string;
    page?: number;
    limit?: number;
    search?: string;
    sort_column?: string;
    sort_direction?: string;
  }) => {
    try {
      const params: any = { agency_id };
      if (page !== undefined) params.page = page;
      if (limit !== undefined) params.limit = limit;
      if (search && typeof search === 'string' && search.trim() !== "")
        params.search = search;
      if (sort_column && typeof sort_column === 'string' && sort_column.trim() !== "")
        params.sort_column = sort_column;
      if (sort_direction && typeof sort_direction === 'string' && sort_direction.trim() !== "")
        params.sort_direction = sort_direction;
      const response = await axiosInstance.get("/users", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }
);

export const addNewUser:any = createAsyncThunk("contacts/addNewUser", async (user : any) => {
    try {
        const response = addNewUserApi(user);
        return response;
    } catch (error) {
        return error;
    }
});

export const deleteUser: any = createAsyncThunk(
  "contacts/deleteUser", // Name of the action
  async (userId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/users/${userId}`);
      return response.data;
    } catch (error: any) {
      console.error("Error deleting user:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateUser:any = createAsyncThunk(
    "contacts/updateContact",
    async (user: any) => {
        try {
            const config = {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
            };
            const response = await axiosInstance.post(`/add-edit-user`, user, config);
            return response.data;
        } catch (error) {
            return error;
        }
    }
);
